module.exports = __webpack_public_path__ + "img/symbol_8.3ca2adb6.png";